/* eslint-disable import/prefer-default-export */
import loginService from './loginService';
import userService from './userService';
import vipService from './vipService';

let initStatePromise: Promise<boolean> | null = null;
/**
 * 初始化用户状态
 */
export const initUserState = async (): Promise<boolean> => {
  initStatePromise = initStatePromise || new Promise((resolve) => {
    loginService.init().then(() => Promise.allSettled([
      userService.init(), vipService.init(),
    ])).then(() => {
      resolve(!!loginService.isLogin);
    }).catch(() => resolve(false));
  });
  return initStatePromise;
};

// 导出响应式对象
export { loginService, userService, vipService };
